export default __webpack_public_path__ + "static/media/02.00e0f979.jpg";